export const siteInfo = {
  name: "51cg网",
  tagline: "综合性网络服务平台",
  description: "51cg网是用户信赖的综合性网络平台，提供便捷的场景化服务体验，覆盖多种网络服务需求，帮助用户快速上手使用。",
  url: "https://www.51cg.com",
  logo: "51cg网",
  foundingYear: "2018",
  email: "service@51cg.com",
  phone: "400-888-5100",
  address: "北京市海淀区中关村科技园区",
  wechat: "51cg_service",
  qq: "800051000",
  workingHours: "周一至周五 9:00-18:00",
};

export const brandStory = `
51cg网成立于2018年，致力于为广大用户提供高效、便捷、安全的综合性网络服务。经过多年的技术积累和服务优化，51cg网已发展成为覆盖多种场景的一站式网络服务平台。

我们的使命是"让网络服务更简单"，通过持续的技术创新和用户体验优化，帮助每一位用户轻松享受数字化生活带来的便利。无论是日常办公、学习提升，还是生活娱乐，51cg网都能为您提供专业可靠的解决方案。

目前，51cg网已累计服务超过500万用户，平台日均活跃用户超过30万，用户满意度保持在98%以上。我们始终坚持以用户为中心，不断优化产品体验，拓展服务边界。
`;

export const reputationList = [
  { title: "工信部备案认证", description: "依法完成ICP备案，合规经营，信息透明可查" },
  { title: "ISO 27001 信息安全认证", description: "通过国际信息安全标准认证，用户数据安全有保障" },
  { title: "AAA级信用企业", description: "荣获中国企业信用评估中心AAA级信用评级" },
  { title: "网络安全等级保护", description: "通过国家网络安全等级保护三级认证" },
  { title: "500万+ 用户信赖", description: "累计服务超过500万用户，口碑相传，值得信赖" },
  { title: "7×24小时客服支持", description: "全天候在线客服，快速响应用户需求" },
];

export const faqList = [
  {
    q: "51cg网是什么？",
    a: "51cg网是一个综合性网络服务平台，为用户提供多种便捷的网络服务功能。平台集成了信息查询、工具应用、社区互动等核心功能，旨在帮助用户高效解决日常网络使用中的各类需求。",
  },
  {
    q: "如何注册51cg网账号？",
    a: "您可以通过以下步骤注册：1）访问51cg网官方首页；2）点击右上角「注册」按钮；3）填写手机号或邮箱，设置密码；4）完成验证码验证；5）点击确认注册即可。整个过程不超过2分钟。",
  },
  {
    q: "忘记密码怎么办？",
    a: "在登录页面点击「忘记密码」，输入您注册时使用的手机号或邮箱，系统会发送验证码。验证成功后即可重新设置密码。如遇到问题，可联系在线客服获取帮助。",
  },
  {
    q: "51cg网有哪些核心功能？",
    a: "核心功能包括：信息聚合浏览、在线工具应用、社区互动交流、个性化内容推荐、数据统计分析等。平台不断更新迭代，定期推出新功能以满足用户多样化的需求。",
  },
  {
    q: "51cg网是否免费使用？",
    a: "51cg网的核心基础功能对所有注册用户完全免费开放。部分高级功能或增值服务可能需要付费使用，具体以平台内展示为准。新注册用户通常可获得一定期限的高级功能试用。",
  },
  {
    q: "如何联系51cg网客服？",
    a: "您可以通过以下方式联系我们：1）在线客服（平台右下角）；2）客服邮箱：service@51cg.com；3）客服电话：400-888-5100；4）微信公众号：51cg_service。客服工作时间为周一至周五 9:00-18:00。",
  },
  {
    q: "51cg网支持哪些设备访问？",
    a: "51cg网全面支持PC端（Windows/Mac）、移动端（iOS/Android）以及平板设备访问。PC端通过浏览器直接访问官网，移动端可通过浏览器或官方App使用我们的服务。",
  },
  {
    q: "如何获取51cg网的最新动态？",
    a: "您可以关注我们的官方微信公众号「51cg_service」、官方微博，或定期访问51cg网首页的「最新资讯」栏目，获取平台更新、活动通知和使用技巧等内容。",
  },
];